import { render, staticRenderFns } from "./LastLoginRecommendCard.vue?vue&type=template&id=5fc58732&scoped=true"
import script from "./LastLoginRecommendCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LastLoginRecommendCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LastLoginRecommendCard.vue?vue&type=style&index=0&id=5fc58732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc58732",
  null
  
)

export default component.exports